export const loginActionType = {
  GET_ACCOUNT: "get_account",
  SIGNIN: "signin",
  SIGNIN_SUCCESS: "signin_success",
  SIGNIN_ERROR: "signin_error",
};
